import { Component, EventEmitter, Input, Output } from '@angular/core';

import { RateLookupBase } from '@assetaccountant/core/services/depreciation.service';

@Component({
  selector: 'app-depreciation-lookup-search-item-select',
  templateUrl: './depreciation-lookup-search-item-select.component.html',
  styleUrls: ['./depreciation-lookup-search-item-select.component.scss'],
  standalone: false,
})
export class DepreciationLookupSearchItemSelectComponent {
  @Input() rates: string[];
  @Input() result: RateLookupBase;

  @Output() selectAlternate = new EventEmitter<void>();

  getRate(name: string, result: RateLookupBase) {
    return result.rates?.find(r => r.name === name)?.rate;
  }

  getLife(name: string, result: RateLookupBase) {
    return result.rates?.find(r => r.name === name)?.life;
  }

  getRateAbbr(name: string, result: RateLookupBase) {
    return result.rates?.find(r => r.name === name)?.code;
  }
}
